<template>
    <RouterLink :to="{ name: 'home' }" class="logo" :aria-label="t('meta.siteName')">
        <img :src="logoUrl" :alt="t('meta.siteName')" class="logo-img" />
    </RouterLink>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import logoUrl from '@/assets/logo.svg'

const { t } = useI18n()
</script>

<style scoped>
.logo {
    display: inline-flex;
    align-items: center;
    height: 100%;
    text-decoration: none;
    line-height: 0;
}

.logo:hover {
    text-decoration: none;
}

.logo-img {
    height: 32px;
    width: auto;
    display: block;
    transition: filter 200ms ease;
}

[data-dx-theme="dx.fluent.blue.dark"] .logo-img {
    filter: invert(1) hue-rotate(180deg);
}

@media (min-width: 768px) {
    .logo-img {
        height: 36px;
    }
}
</style>
